import { render, staticRenderFns } from "./VideoArea.vue?vue&type=template&id=17d22188&scoped=true"
import script from "./VideoArea.vue?vue&type=script&lang=js"
export * from "./VideoArea.vue?vue&type=script&lang=js"
import style0 from "./VideoArea.vue?vue&type=style&index=0&id=17d22188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d22188",
  null
  
)

export default component.exports